import { styled } from "@mui/system";

const InputCustom = styled("input")(({ disabled, theme }) => ({
  width: "100%",
  padding: "12px 16px",
  borderRadius: "16px",
  background: disabled ? "#F3F1F2" : "transparent",
  border: "1px solid #D8D8DC",
  fontSize: "1rem",
  fontWeight: "400",
  height: "48px",
  fontFamily: "Poppins, Prompt, Caveat",

  [theme.breakpoints.down("sm")]: {
    height: "40px",
    fontSize: "0.875rem",
  },
}));

const InputText = ({ disabled = false, value, onChange }) => {
  return <InputCustom disabled={disabled} value={value} onChange={onChange} />;
};

export default InputText;
